import { createStore } from 'vuex'
import axios from 'axios';
import { StreamChat } from "stream-chat";


export default createStore({
  state: {
    isLogin: false,
    userId: null,
    userName: "",
    mobile: "",
    avatar: null,
    loading: true,
    myRoute:"",
    // for test
    // baseURL:"https://backdev.amaqaria.com/",
    // mediaURL:"https://backdev.amaqaria.com/uploads/",
    // backend:"https://backdev.amaqaria.com",
    // frontEnd:"https://dev.amaqaria.com",
    // for production
    baseURL:"https://backend.aqaralmuhaysini.com/",
    mediaURL:"https://backend.aqaralmuhaysini.com/uploads/",
    backend:"https://backend.aqaralmuhaysini.com",
    frontEnd:"https://aqaralmuhaysini.com",
    poupShow: true,
    balance: null,
    nafathStatus: '',
    streamToken: null,
    streamId: null,
    chatClient: null,
    userCode: "",
    accountType: "",
  },
  getters: {
    GET_USER(state){
      return state.isLogin;
    },
    GET_USER_DATA(state){
      return {
        userId: state.userId,
        userName: state.userName,
        mobile: state.mobile,
        avatar: state.avatar,
        nafathStatus: state.nafathStatus,
        streamToken: state.streamToken,
        streamId: state.streamId,
        userCode: state.userCode,
        accountType: state.accountType,
      }
    },
    ISLOADING(state){
      return state.loading;
    },
    BASE_URL(state){
      return state.baseURL;
    },
    MEDIA_URL(state){
      return state.mediaURL;
    },
    BACKEND_URL(state){
      return state.backend;
    },
    FRONTEND_URL(state){
      return state.frontEnd;
    },
    GET_ROUTE(state){
      return state.myRoute;
    },
    GET_POUPSHOW(state){
      return state.poupShow;
    },
    USER_WALLET_BALANCE(state){
      return state.balance;
    },
    CHAT_CLIENT(state){
      return state.chatClient;
    }
  },
  mutations: {
    SET_USER_DATA(state, user){
      state.isLogin = true;
      if(user.token){
        localStorage.setItem('userToken', user.token);
      }
      state.userId = user.id;
      state.userName = user.name;
      state.mobile = user.mobile;
      state.userCode = user.userCode;
      state.avatar = user.avatar ?? null;
      state.nafathStatus = user.nafathStatus ?? '';
      state.balance = user.balance ?? 0;
      state.streamToken = user.streamToken ?? null;
      state.streamId = user.streamId ?? null;
      state.accountType = user.accountType ?? null;

      if(user.streamToken){
        state.chatClient = StreamChat.getInstance("9u5sfhq2nx3t", {
          timeout: 6000,
        });
  
        const userObj = {
          id: user.streamId,
          name: user.name,
          image: (user.avatar)? `${state.mediaURL}${user.avatar}` : null,
        };
        const userToken = user.streamToken;
        
        state.chatClient.connectUser(userObj, userToken).then(() => {
          state.loading = false;
        }).catch(err => {
          state.chatClient = null;
          state.loading = false;
        });
      }else{
        state.loading = false;
      }
    },

    REMOVE_USER_DATA(state){
      state.isLogin = false,
      localStorage.removeItem('userToken');
      if(state.chatClient)
        state.chatClient.disconnectUser().then(() => {
          state.chatClient = null;
        });
      state.loading = false;
    },

    SET_POUPSHOW(state){
      state.poupShow = false;
    },
    SET_ROUTE: (state, route) => state.myRoute = route.name,
  },
  actions: {
    async checkUser(context){
      if(localStorage.getItem('userToken')){
        // axios.defaults.headers.common['X-Aqaria-Token'] = localStorage.getItem('userToken');
        axios.get('/api/users/currentUser').then( res => {
          // console.log(res);
          context.commit('SET_USER_DATA', res.data.user);
        }).catch(err => {
          context.commit("REMOVE_USER_DATA");
        });
      } else {
        context.commit("REMOVE_USER_DATA");
      }
    }
  },
  modules: {
  }
})
